import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IExtraCartItem, IReservationData, LanguageService } from 'core-lib';
import { ImageGallery1Component } from '../image-gallery1/image-gallery1.component';
import { HttpClient } from '@angular/common/http';
import { CurrencyPipe } from '@angular/common';
import { formatRateNamePipe } from "../../pipes/format-rate-name.pipe";
import { StripTagsPipe } from '../../pipes/stripTags.pipe';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'app-confirmation-roominfo',
    imports: [TranslateModule, ImageGallery1Component, CurrencyPipe, formatRateNamePipe, StripTagsPipe, MessageModule],
    templateUrl: './confirmation-roominfo.component.html',
    styleUrl: './confirmation-roominfo.component.scss'
})
export class ConfirmationRoominfoComponent {
  @Input() roomInfo: IReservationData
  @Input() isMultiRoomBooking:boolean = false;
  countryList:any;
  language:string;
  onlyRoomPrice:number;
  hasExternalExtras: boolean = false;

  constructor(private http: HttpClient, private languageService: LanguageService) {
    
  }

  ngOnInit() {
    this.language = this.languageService.getCurrentLanguage();
    this.loadCountryList();
    this.calculateOnlyRoomPrice();

    let foundExternalExtra = this.roomInfo.extras?.find((extra) => {return extra.isTicket}); 
    this.hasExternalExtras = !!foundExternalExtra;
  }

  getCountryName(iso2Code:string|null) {
    if (iso2Code) {
      let code = iso2Code.toLowerCase()
      let countryItem = this.countryList.find((item:any) => {return code == item.alpha2});
      return countryItem.name;
    }
    return "";
  }

  loadCountryList() {
    this.http.get(`./countries/${this.language}/countries.json`).subscribe((res:any) => {
      this.countryList = res;
    });
  }

  calculateOnlyRoomPrice() {
    let total = this.roomInfo.roomRate.totalPriceForStayWithTaxes;
    if (this.roomInfo.extras) {
      this.roomInfo.extras.forEach((extra:IExtraCartItem) => {
        total = total - extra.totalPriceForStayWithTaxes
      });
    }
    this.onlyRoomPrice = total;
  }

}
